module.exports = __webpack_public_path__ + "static/media/AnglesInACircle.dacaf881.jpg";